import React from 'react';


const About = () => {
    return (
        <div>
            <p className="about">This is a practice app to learn REACT and components. Here we use routing and nested routing.</p>
        </div>
    );
};

export default About;